import type {
  BankIncomingLine,
  MatchedBankLine,
  TransactionBankMatchView,
} from '@/types/bank-reconciliation';
import { apiClient } from '@/utils/api-client';

// Bank reconciliation: read the fund's "bank incoming" lines and match one
// manually to a fund transaction (fully or in part).
export class BankReconciliationService {
  static async getBankIncoming(fundId: string): Promise<BankIncomingLine[]> {
    return apiClient.get<BankIncomingLine[]>(`/funds/${fundId}/bank-incoming`);
  }

  static async matchIncoming(
    fundId: string,
    incomingId: string,
    fundTransactionId: string
  ): Promise<MatchedBankLine> {
    return apiClient.post<MatchedBankLine>(
      `/funds/${fundId}/bank-incoming/${incomingId}/match`,
      { fund_transaction_id: fundTransactionId }
    );
  }

  static async getTransactionBankMatching(
    fundId: string,
    fundTransactionId: string
  ): Promise<TransactionBankMatchView> {
    return apiClient.get<TransactionBankMatchView>(
      `/funds/${fundId}/fund-transactions/${fundTransactionId}/bank-matching`
    );
  }
}
